import {
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import {
  AbstractControl,
  ControlContainer,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { FormInputComponent } from '../form-input.component';
import { ToFormControlPipe } from '../../../../pipes/to-form-control/to-form-control.pipe';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { ColorPickerDirective } from 'ngx-color-picker';

@Component({
  selector: 'aw-color-picker-input',
  imports: [
    CommonModule,
    ErrorMessageComponent,
    ReactiveFormsModule,
    ToFormControlPipe,
    AppendTestIdPipe,
    ColorPickerDirective,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './color-picker-input.component.html',
})
export class ColorPickerInputComponent
  extends FormInputComponent
  implements OnInit, OnDestroy
{
  @HostBinding('class') hostClass: string = '';
  public color: string =
    this.corporateDesignService.isDarkModeActive() || this.isManualDarkMode()
      ? this.corporateDesignService.corporateDesign().colorAdmixtures
          .dark_text_disabled
      : '#000000';
  public defaultColor: string = '#000000';

  @ViewChild(ColorPickerDirective)
  colorPicker!: ColorPickerDirective;

  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }

  ngOnInit() {
    this.ngControl.control!.addValidators(this.isHexColor());
    this.subscription.add(
      this.ngControl.control!.valueChanges.subscribe(value => {
        this.color = value;
      })
    );
    if (!this.ngControl.control!.value) {
      this.ngControl.control!.setValue(this.defaultColor, { emitEvent: false });
    } else {
      this.color = this.ngControl.control!.value;
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.ngControl.control!.removeValidators(this.isHexColor());
  }

  openColorPicker(): void {
    this.colorPicker.openDialog();
  }

  changeColor(color: string): void {
    this.ngControl.control!.setValue(color);
    this.ngControl.control!.markAsTouched();
    this.ngControl.control!.markAsDirty();
  }

  positionPicker(isOpen: boolean): void {
    if (isOpen) {
      document.body.style.setProperty('overflow', 'hidden');
      const colorPicker: HTMLElement = document.getElementsByClassName(
        'color-picker'
      )[0] as HTMLElement;
      const arrow: Element = colorPicker.getElementsByClassName(
        'arrow arrow-bottom-left'
      )[0];
      colorPicker.style.setProperty('position', 'absolute');
      colorPicker.style.setProperty('left', '40px');
      colorPicker.style.setProperty('top', '7px');
      arrow?.setAttribute('class', 'arrow arrow-bottom-right');
    } else {
      document.body.style.setProperty('overflow', 'initial');
    }
  }

  updateColorPickerValue(): void {
    if (this.ngControl.control!.valid) {
      this.color = this.ngControl.control!.value;
    } else {
      this.color = this.defaultColor;
      this.ngControl.control!.setValue(this.defaultColor, { emitEvent: false });
    }
  }

  private isHexColor(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value === undefined || control.value === null) {
        return null;
      }
      const sixCharacterCode = new RegExp('^#[0-9A-Fa-f]{6}$');
      const hexError = control.value.toString().match(sixCharacterCode);
      return !hexError ? { hexColor: true } : null;
    };
  }
}
